import {Inject, Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {CookieService} from 'ngx-cookie-service';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'jalali-moment';
import {ImageViewerModalComponent} from '../modals/image-viewer-modal/imageViewerModal..component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ProfileModalComponent} from '../modals/profile-modal/profileModal.component';
import {ModalComponent} from '../modals/addEditDel/modal.component';

@Injectable({providedIn: 'root'})
export class InternalService {
  public key: any;
  public isParent: any;
  public userId: any;
  public maxHeight: any = '500px';
  public maxWidth: any = '800px';
  public height: any = '200px';
  public width: any = '300px';
  public profilePic: any;
  dialogConfig = new MatDialogConfig();


  constructor(public translate: TranslateService,
              public apiService: ApiService,
              private ngbModal: NgbModal,
              private dbService: NgxIndexedDBService,
              public toastr: ToastrService,
              public dialog: MatDialog,
              private cookieService: CookieService) {

  }

  open() {
    this.ngbModal.open({windowClass: 'addEditDel-holder', centered: true, size: 'lg'});
  }

  getTimestamp($event) {
    if (this.apiService.currentDirection === 'rtl') {
      const dateShamsiToMiladi = moment.from(Number($event.year) + '-' + Number($event.month) +
        '-' + Number($event.day), 'fa').format('YYYY-MM-DD');
      const datemiladi = dateShamsiToMiladi.split('-');
      const UTCDate = new Date(Number(datemiladi[0]), Number(datemiladi[1]) - 1, Number(datemiladi[2]));

      return (-(UTCDate.getTimezoneOffset()) * 60) + (UTCDate.getTime() / 1000);
    } else {
      const miladi = Number($event.year) + '-' + Number($event.month) + '-' + Number($event.day);
      const datemiladi = miladi.split('-');
      const UTCDate = new Date(Number(datemiladi[0]), Number(datemiladi[1]) - 1, Number(datemiladi[2]));
      return (-(UTCDate.getTimezoneOffset()) * 60) + (UTCDate.getTime() / 1000);
    }
  }

  changeLang(language: string, id) {
    if (language === 'fa-ir') {
      this.cookieService.set('lang', '1');
    } else {
      this.cookieService.set('lang', '2');
    }
    // the methode for change lang and direction of whole website
    this.translate.use(language);
    this.translate.get('dir', language).subscribe(
      (res) => {

        this.apiService.currentDirection = res;

        const dom: any = document.querySelector('body');

        if (res === 'rtl' && !dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 1);
          dom.classList.toggle('rtl');

          if (id !== 0) {
            window.location.reload();
          }
        }
        if (res === 'ltr' && dom.classList.contains('rtl')) {

          this.apiService.onSetLanguage(res, 2);
          dom.classList.toggle('rtl');
          if (id !== 0) {
            window.location.reload();
          }
        }
      }
    );
  }

  BlockUnBlock(id, flag) {
    if (this.cookieService.get('userId') === id) {
      this.apiService.showMessage('Message.YouCanotDoAnyActionOnYourself', 0);
      return;
    }
    // console.log(flag);
    this.apiService.apiCall('put', '/api/Moderate/PutToggleBlock/' + id, {}).subscribe((response: any) => {
      // console.log(response);
      if (response.stu === 1) {

        if (flag) {
          this.apiService.showMessage('Message.SuccessfullyBlocked', response.stu);
        } else if (!flag) {
          this.apiService.showMessage('Message.SuccessfullyUnblocked', response.stu);
        }

      } else {
        this.translate.get('Message.ServerError').subscribe((resError) => {
          this.toastr.error(resError);
        });
      }
    }, error => {
      this.translate.get('Message.ServerError').subscribe((response) => {
        this.toastr.error(response);
      });
    });

  }

  async getMd5(image) {
    if (image.includes('https://')) {
      return image;
    } else {
      // debugger
      const result = await this.dbService.getByIndex('Images', 'MD5', image).toPromise();
      if (result === undefined) {
// ----------------------------------------check number of rows in a store-------------------------
        this.dbService.count('Images').subscribe((count) => {
          // console.log('count', count);
          if (count > 100) {
            this.dbService.clear('Images').subscribe((successDeleted) => {
              // console.log('success? ', successDeleted);
            });
          }
        });
// ------------------------------------------------insert store-------------------------------------
        const response = await this.apiService.apiCall('get', '/api/image/GetImage/' + image, {}).toPromise();
        this.dbService
          .add('Images', {
            MD5: image,
            // icon: response['res']['imageFormat'] + response['res']['imageString'],
            icon: `data:image/png;base64,` + response['res']['imageString'],
          });
        return `data:image/png;base64,` + response['res']['imageString'];
      } else {
        return result.icon;
      }
    }
  }

//   async getSkillMd5(image) {
    
//     if (image.includes("https://")) {
//       return image
//     } else {
//       const result = await this.dbService.getByIndex('Images', 'MD5', image).toPromise();
      
//       if (result === undefined || result.icon == "data:image/png;base64,undefined") {
// // ----------------------------------------check number of rows in a store-------------------------
//         this.dbService.count('Images').subscribe((count) => {
//           // console.log('count', count);
//           if (count > 100) {
//             this.dbService.clear('Images').subscribe((successDeleted) => {
//               // console.log('success? ', successDeleted);
//             });
//           }
//         });
// // ------------------------------------------------insert store-------------------------------------
//         const response = await this.apiService.getSkillImage(image).toPromise();
        
//         this.dbService
//           .add('Images', {
//             MD5: image,
//             // icon: response['res']['imageFormat'] + response['res']['imageString'],
//             icon: `data:image/png;base64,`+ response['res']['imageString'],
//           });
//         return `data:image/png;base64,`+ response['res']['imageString'];
//       } else {
//         return result.icon;
//       }
//     }
//   }

  async GetCountries() {
    const countries = await this.apiService.apiCall('get', '/api/location/GetCountries/', {}).toPromise();
    return countries['res'];
  }

  async GetProvinces(countryid) {
    const provinces = await this.apiService.apiCall('get', '/api/location/GetProvinces/' + countryid, {}).toPromise();
    return provinces['res'];
  }

  async GetCities(id) { // load cities
    const cities = await this.apiService.apiCall('get', '/api/location/GetCities/' + id, {}).toPromise();
    return cities['res'];
  }

  async getLanguages() { // system active languages
    const languages = await this.apiService.apiCall('get', '/api/Admin/GetAllLanguages/', {}).toPromise();
    return languages;
  }

  GetAllCategoriesWithGroups(flag) {
    return this.apiService.apiCall('get', '/api/Skill/GetAllCategoriesWithGroups/' + flag, {}).toPromise();
  }

  sendMessageAccessFromProfile() {// only Admin and Administrator can send message
    const rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));
    if (rolesArray.includes('Administrator') || rolesArray.includes('Admin')) {
      return true;
    }
  }

  imageView(image) {
    this.dialogConfig.disableClose = true;
    this.dialogConfig.id = 'ImageViewerModalComponent';
    this.dialogConfig.maxHeight = this.maxHeight;
    this.dialogConfig.maxWidth = this.maxWidth;
    this.dialogConfig.data = {
      name: 'edit',
      actionButtonText: 'Button.Close',
      id: '',
      function: '',
      url: image,
    };
    const modalDialog = this.dialog.open(ImageViewerModalComponent, this.dialogConfig);
  }

  openProfile(id): void {
    this.userId = id;
    const dialogRef = this.dialog.open(ProfileModalComponent, {
      width: '900px',
      data: {},
      id: id
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }

  openDeleteModal(id, modalfunc) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'addEditDel-component';
    dialogConfig.height = this.height;
    dialogConfig.width = this.width;
    dialogConfig.data = {
      name: 'delete',
      title: 'Message.AreYouSureToDelete?',
      description: 'Message.AreYouSureToDelete?',
      actionButtonText: 'Button.Delete',
      id: id,
      function: modalfunc,
    };
    const modalDialog = this.dialog.open(ModalComponent, dialogConfig);
  }

  getMonth(id) {
    if (this.cookieService.get('lang') === '1') {
      switch (id) {
        case 1:
          return 'فروردین';
        case 2:
          return 'اردیبهشت';
        case 3:
          return 'خرداد';
        case 4:
          return 'تیر';
        case 5:
          return 'مرداد';
        case 6:
          return 'شهریور';
        case 7:
          return 'مهر';
        case 8:
          return 'آبان';
        case 9:
          return 'آذر';
        case 10:
          return 'دی';
        case 11:
          return 'بهمن';
        case 12:
          return 'اسفند';
      }
    } else {
      switch (id) {
        case 1:
          return 'Jan';
        case 2:
          return 'Feb';
        case 3:
          return 'Mar';
        case 4:
          return 'Apr';
        case 5:
          return 'May';
        case 6:
          return 'June';
        case 7:
          return 'July';
        case 8:
          return 'Aug';
        case 9:
          return 'Sept';
        case 10:
          return 'Oct';
        case 11:
          return 'Nov';
        case 12:
          return 'Dec';
      }
    }
  }
}
